import { getGRP } from "~lib/getGRP";
import {
  AB_TESTS,
  AMPLIFY_RBK,
  FORCE_AB_TESTS
} from "~lib/keyNamesOfLocalStorage";
import { hasLocalStorage } from "~lib/localStorage";

/***
 * After changes go live we should work on deleting AB tests
 */

// Banners should go live 30 days before SIWI (June 15)
export const ABTEST_RB_RESCOM_HOMEBANNER = "rb_rescom_homebanner";
export const ABTEST_RB_RESCOM_HOMEBANNER1 = "rb_rescom_homebanner1"; // Banner is on the homepage (0%)

export const ABTEST_RB_RESCOM_MAINTENANCE = "rb_rescom_maintenance";
export const ABTEST_RB_RESCOM_MAINTENANCE0 = "rb_rescom_maintenance0"; // Show normal page
export const ABTEST_RB_RESCOM_MAINTENANCE1 = "rb_rescom_maintenance1"; // Redirect to maintenance page

export const ABTEST_RB_RESUME_LIMITATION_MODAL = "rb_resume_limitation_modal";
export const ABTEST_RB_RESUME_LIMITATION_MODAL0 = "rb_resume_limitation_modal0"; // No modal
export const ABTEST_RB_RESUME_LIMITATION_MODAL1 = "rb_resume_limitation_modal1"; // Display limitation modal for 6th resume

export const ABTEST_RB_RESUME_CHOOSE_COLOR = "rb_resume_choose_color"; // For choose template color feature
export const ABTEST_RB_RESUME_CHOOSE_COLOR0 = "rb_resume_choose_color0"; // No color selection
export const ABTEST_RB_RESUME_CHOOSE_COLOR1 = "rb_resume_choose_color1"; // Open color selection

export const ABTEST_RT_INDEED_USER_FEEDBACK = "rt_indeed_user_feedback"; // For all feedback modals
export const ABTEST_RT_INDEED_USER_FEEDBACK0 = "rt_indeed_user_feedback0"; // No feedback modal
export const ABTEST_RT_INDEED_USER_FEEDBACK1 = "rt_indeed_user_feedback1"; // Show feedback modal

export const ABTEST_RB_CRB_CL_AI_WRITER = "rb_crb_cl_ai_writer"; // For AI cover letter
export const ABTEST_RB_CRB_CL_AI_WRITER0 = "rb_crb_cl_ai_writer0";
export const ABTEST_RB_CRB_CL_AI_WRITER1 = "rb_crb_cl_ai_writer1";

export const ABTEST_RB_CRB_INDEED_SECTIONS = "rb_crb_indeed_sections"; // For new added sections
export const ABTEST_RB_CRB_INDEED_SECTIONS0 = "rb_crb_indeed_sections0"; // Do not display any new sections
export const ABTEST_RB_CRB_INDEED_SECTIONS1 = "rb_crb_indeed_sections1"; // Display new sections

/*
Example:
test_name = "rb_rescom_crb"
group_1_id = "rb_rescom_crb0"
group_2_id = "rb_rescom_crb1"

===IN USER'S LOCAL STORAGE===
"ab_tests": {
  "rb_rescom_crb": {
    "group": "rb_rescom_crb0",
    "lastChecked": 1608149962948
  }
}

"force_ab_tests": {
  "rb_rescom_crb": "rb_rescom_crb1"
}

to test for group membership, an example call would be:
 isInGroup(ABTEST_RB_RESCOM_CRB, ABTEST_RB_RESCOM_CRB1);

*/

export const isInGroup = async (
  testID: string,
  groupID: string
): Promise<boolean> => {
  let group = null;

  if (hasLocalStorage()) {
    // Guests need to be able to be AB tested, and this is before they are created in the database.
    const __rbk = localStorage.getItem(AMPLIFY_RBK) || null;
    const userID = __rbk && (JSON.parse(__rbk)["data"] || null);

    // First we check to see if a superuser is forcing themselves into a test group.
    const forceABTests = localStorage.getItem(FORCE_AB_TESTS) || null;
    if (forceABTests !== null) {
      group = JSON.parse(forceABTests)[testID] || null;
    }

    /*
      Next we check for a cached group. If the group has not been pulled in the last 30 minutes, we grab a new one.
      This is because:
        - The test groups may have been rebalanced
        - The test may have been turned off, and the user is put back into the default group
        - We don't want to send lambda/GraphQL requests too often
    */
    if (group == null) {
      const abTests = localStorage.getItem(AB_TESTS) || null;
      const parsedABTests = abTests && (JSON.parse(abTests) || null);
      const test = parsedABTests && (parsedABTests[testID] || null);
      const lastChecked = parsedABTests && (parsedABTests.lastChecked || 0);

      const currentTime = new Date().getTime();
      if (test === null || (currentTime - lastChecked) / 60000 > 30) {
        const response = await getGRP(testID, userID);
        group = (await response?.data?.group) || testID + "0";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        localStorage.setItem([testID], group);
        const newGroup = {
          ...searchABtestGroup(),
          lastChecked: currentTime
        };
        localStorage.setItem(AB_TESTS, JSON.stringify(newGroup));
      } else {
        group = test;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        localStorage.removeItem([testID]);
      }
    }
  }
  return group === groupID;
};

export const isInGroupRbRescomHomeBanner = () =>
  isInGroup(ABTEST_RB_RESCOM_HOMEBANNER, ABTEST_RB_RESCOM_HOMEBANNER1);

export const isInGroupRbRescomMaintenance = () =>
  isInGroup(ABTEST_RB_RESCOM_MAINTENANCE, ABTEST_RB_RESCOM_MAINTENANCE1);

export const isInGroupRbResumeLimitationModal0 = () =>
  isInGroup(
    ABTEST_RB_RESUME_LIMITATION_MODAL,
    ABTEST_RB_RESUME_LIMITATION_MODAL0
  );

export const isInGroupRbResumeLimitationModal1 = () =>
  isInGroup(
    ABTEST_RB_RESUME_LIMITATION_MODAL,
    ABTEST_RB_RESUME_LIMITATION_MODAL1
  );

export const isInGroupRbResumeChooseColor0 = () =>
  isInGroup(ABTEST_RB_RESUME_CHOOSE_COLOR, ABTEST_RB_RESUME_CHOOSE_COLOR0);

export const isInGroupRbResumeChooseColor1 = () =>
  isInGroup(ABTEST_RB_RESUME_CHOOSE_COLOR, ABTEST_RB_RESUME_CHOOSE_COLOR1);

export const isInGroupRtIndeedUserFeedback0 = () =>
  isInGroup(ABTEST_RT_INDEED_USER_FEEDBACK, ABTEST_RT_INDEED_USER_FEEDBACK0);

export const isInGroupRtIndeedUserFeedback1 = () =>
  isInGroup(ABTEST_RT_INDEED_USER_FEEDBACK, ABTEST_RT_INDEED_USER_FEEDBACK1);

export const isInGroupRbCrbClAiWriter0 = () =>
  isInGroup(ABTEST_RB_CRB_CL_AI_WRITER, ABTEST_RB_CRB_CL_AI_WRITER0);

export const isInGroupRbCrbClAiWriter1 = () =>
  isInGroup(ABTEST_RB_CRB_CL_AI_WRITER, ABTEST_RB_CRB_CL_AI_WRITER1);

export const isInGroupRbCrbIndeedSections0 = () =>
  isInGroup(ABTEST_RB_CRB_INDEED_SECTIONS, ABTEST_RB_CRB_INDEED_SECTIONS0);

export const isInGroupRbCrbIndeedSections1 = () =>
  isInGroup(ABTEST_RB_CRB_INDEED_SECTIONS, ABTEST_RB_CRB_INDEED_SECTIONS1);

const searchABtestGroup = () => {
  const abTestsGroupsArr = [
    ABTEST_RB_RESCOM_HOMEBANNER,
    ABTEST_RB_RESCOM_MAINTENANCE,
    ABTEST_RB_RESUME_LIMITATION_MODAL,
    ABTEST_RB_RESUME_CHOOSE_COLOR,
    ABTEST_RT_INDEED_USER_FEEDBACK,
    ABTEST_RB_CRB_CL_AI_WRITER,
    ABTEST_RB_CRB_INDEED_SECTIONS
  ];
  const allTestGroups = {};
  for (const index in abTestsGroupsArr) {
    const abTest = localStorage.getItem(abTestsGroupsArr[index]);
    if (abTest) {
      allTestGroups[abTestsGroupsArr[index]] = localStorage.getItem(
        abTestsGroupsArr[index]
      );
    }
  }
  return allTestGroups;
};
